import React from 'react';
import BaseTeaserSmall from './Base';
import EntityTeaserSmall from './Entity';

import './style.scss';


const TeaserSmall = (props) => {
  const { node } = props;

  if (node) {
    return (
      <EntityTeaserSmall {...props} />
    );
  }

  return <BaseTeaserSmall {...props} />;
};

export default TeaserSmall;
